import { useContext, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, ROLE, SIZE } from 'baseui/modal';
import { nanoid } from 'nanoid';
import { Button, ButtonRow } from '@gtintel/platform-atoms';
import { CLOSED_ID, DAYS_TO_RETAIN_DATA_AFTER_PROJECT_CLOSED } from '@gtintel/platform-constants';
import { ProjectContext } from '../../../ProjectApp/context';
const PROJECT_CLOSE_EFFECTS = ['Project Chat history will be unavailable', 'NP access will be removed', `Reports will be removed ${DAYS_TO_RETAIN_DATA_AFTER_PROJECT_CLOSED} days after closing date`];
const CloseProjectButton = () => {
  const {
    edit
  } = useContext(ProjectContext);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  return <>
      <Modal onClose={() => setIsOpen(false)} closeable isOpen={isOpen} animate autoFocus size={SIZE.default} role={ROLE.dialog}>
        <ModalHeader>Are you sure you want to close this project?</ModalHeader>
        <ModalBody>
          <p>If you choose to close this Project, the following will happen:</p>
          <ul>
            {PROJECT_CLOSE_EFFECTS.map(effect => <li key={nanoid()}>{effect}</li>)}
          </ul>
          <p>
            If you want more work, or a phase 2, on this project, you will have
            to create a new one.
          </p>
        </ModalBody>
        <ModalFooter>
          <ButtonRow flexPosition="flex-end">
            <Button kind="error" testId="confirm-close-project-button" loading={isLoading} disabled={isLoading} onClick={() => {
            setIsLoading(true);
            edit({
              status: CLOSED_ID
            });
            setIsLoading(false);
            setIsOpen(false);
          }}>
              Close Project
            </Button>
            <Button kind="secondary" testId="cancel-close-project-button" onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
          </ButtonRow>
        </ModalFooter>
      </Modal>
      <Button kind="error" testId="close-project-button" loading={isLoading} disabled={isLoading} onClick={() => setIsOpen(true)}>
        Close Project
      </Button>
    </>;
};
export default CloseProjectButton;